import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-vb-payments-annual-total',
  templateUrl: './vb-payments-annual-total.component.html',
  styleUrls: ['./vb-payments-annual-total.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsAnnualTotalComponent {
  @Input({ required: true }) annualTotal!: number;
}
